module.exports = __webpack_public_path__ + "img/Search.4045f20d.svg";